
function setBurgerInfoHeight() {
    const scaleWidthMB = 768;
    const navHeight = 80;
    const scale = window.innerWidth / scaleWidthMB;
    const height = window.innerHeight / scale;
    $('#navigation .burger-info').css('height', height + 'px');
    $('#navigation .list-navs').css('max-height', (height - navHeight) + 'px');
}

window.addEventListener("load", function () {
    setBurgerInfoHeight();
    window.addEventListener('resize', setBurgerInfoHeight);

    $('#navigation .list-navs a').on('click', function () {
        if (!$(this).siblings('.sub-navs').length) {
            $('#navigation').removeClass('active');
        }
    });

    $('#navigation .list-navs > li').on('click', function () {
        $('#navigation .list-navs > li').removeClass('active');
        $(this).addClass('active');
    });

    // index theo thứ tự li trong .list-navs: 0=Trang Chủ, 1=Tin Tức, 2=logo, 3=Hỗ Trợ, 4=Cộng Đồng
    const sectionNavMap = {
        'header': 0,
        'news': 1,
    };

    const $navLis = $('#navigation .list-navs > li');

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                const idx = sectionNavMap[entry.target.id];
                if (idx !== undefined) {
                    $navLis.removeClass('active');
                    $navLis.eq(idx).addClass('active');
                }
            }
        });
    }, { threshold: 0.3 });

    Object.keys(sectionNavMap).forEach(function (id) {
        const el = document.getElementById(id);
        if (el) observer.observe(el);
    });

    // const $item = $('#navigation .list-navs > li').eq(2);
    // console.log($item);
    // $item.on('click', function (e) {
    //     e.preventDefault();

    //     $('#libraryMainsite-t-float_left .list-btns a').last().trigger('click');
    // });

});

